import {initialState} from "./state";

export const attendance = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ATTENDANCE_INFO':
      return {
        ...state,
        attendanceInfo: action.data,
      };
    default:
      return state;
  }
};
